import { AccordionDetails, Button, Grid, TextField } from "@mui/material";
import ExerciseLogDetails from "./ExerciseLogDetails";
import React, { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";

const ExerciseDetails = ({ logs, exercise_id }) => {
  const initialExerciseData = Array(4).fill().map(() => ({ weight: '', ease: '', repetition: '', shoulderPain: '' }));
  const [exercisesData, setExercisesData] = useState(initialExerciseData);
  const [notes, setNotes] = useState('');

  // Handle change in input fields
  const handleInputChange = (rowIndex, field) => (event) => {
    const updatedExercisesData = exercisesData.map((data, index) => index === rowIndex ? { ...data, [field]: event.target.value } : data);
    setExercisesData(updatedExercisesData);
  };

  // Handle form submission
  const handleSubmit = () => {
    // Here you would send this data to the backend
    let data = {
      "exercise": exercise_id, "sets_and_reps": exercisesData, "performed_at": new Date().toISOString(), "notes": notes,
    }

    // Make a post API call using axios to http://gymbackend-env.eba-kw3jn3jh.us-west-2.elasticbeanstalk.com/exerciselogs/
    // and show a toast using react-toastify if successful
    axios.post('http://gymbackend-env.eba-kw3jn3jh.us-west-2.elasticbeanstalk.com/exerciselogs/', data)
      .then((response) => {
        console.log(response);
        toast.success(`Exercise log added successfully! Average went from ${response.data.average_old} to ${response.data.average_new}!`);
      }, (error) => {
        console.log(error);
        toast.error('Error adding exercise log!');
      });
  };

  return (<>
    <AccordionDetails>
      <ToastContainer/>
      {Array(4).fill().map((_, rowIndex) => (<Grid container spacing={2} style={{ marginTop: '1px' }} key={rowIndex}>
        <Grid item xs={3} sm={3}>
          <TextField
            label="Weight"
            variant="outlined"
            size="small"
            value={exercisesData[rowIndex].weight}
            inputProps={{ inputMode: "numeric" }}
            onChange={handleInputChange(rowIndex, 'weight')}/>
        </Grid>
        <Grid item xs={3} sm={3}>
          <TextField
            label="Repetition"
            variant="outlined"
            size="small"
            value={exercisesData[rowIndex].repetition}
            inputProps={{ inputMode: "numeric" }}
            onChange={handleInputChange(rowIndex, 'repetition')}/>
        </Grid>
        <Grid item xs={3} sm={3}>
          <TextField
            label="Ease"
            variant="outlined"
            size="small"
            value={exercisesData[rowIndex].ease}
            inputProps={{ inputMode: "numeric" }}
            onChange={handleInputChange(rowIndex, 'ease')}/>
        </Grid>
        <Grid item xs={3} sm={3}>
          <TextField
            label="Shoulder Pain"
            variant="outlined"
            size="small"
            value={exercisesData[rowIndex].shoulderPain}
            inputProps={{ inputMode: "numeric" }}
            onChange={handleInputChange(rowIndex, 'shoulderPain')}/>
        </Grid>
      </Grid>))}

      <TextField
        label="Notes"
        variant="outlined"
        size="small"
        fullWidth
        multiline
        value={notes}
        onChange={(event) => setNotes(event.target.value)}
        style={{ marginTop: '15px' }}></TextField>

      <Button variant="contained" fullWidth style={{ marginTop: '10px' }} onClick={handleSubmit}>
        Add Sets
      </Button>

      {logs.length > 0 && logs.map((log, index) => (<ExerciseLogDetails key={index} log={log}/>))}

    </AccordionDetails>
  </>);
}

export default ExerciseDetails;